import { languageHelper } from "./LanguageHelper";
import en_us from "../translations-meet-now/en-US/LocalizedStrings.json";

import ar_sa from "../translations-meet-now/ar-SA/LocalizedStrings.json";
import bg_bg from "../translations-meet-now/bg-BG/LocalizedStrings.json";
import cs_cz from "../translations-meet-now/cs-CZ/LocalizedStrings.json";
import da_dk from "../translations-meet-now/da-DK/LocalizedStrings.json";
import de_de from "../translations-meet-now/de-DE/LocalizedStrings.json";
import el_gr from "../translations-meet-now/el-GR/LocalizedStrings.json";
import es_es from "../translations-meet-now/es-ES/LocalizedStrings.json";
import et_ee from "../translations-meet-now/et-EE/LocalizedStrings.json";
import fi_fi from "../translations-meet-now/fi-FI/LocalizedStrings.json";
import he_il from "../translations-meet-now/he-IL/LocalizedStrings.json";
import hi_in from "../translations-meet-now/hi-IN/LocalizedStrings.json";
import hu_hu from "../translations-meet-now/hu-HU/LocalizedStrings.json";
import id_id from "../translations-meet-now/id-ID/LocalizedStrings.json";
import it_it from "../translations-meet-now/it-IT/LocalizedStrings.json";
import ja_jp from "../translations-meet-now/ja-JP/LocalizedStrings.json";
import ko_kr from "../translations-meet-now/ko-KR/LocalizedStrings.json";
import nl_nl from "../translations-meet-now/nl-NL/LocalizedStrings.json";
import nb_no from "../translations-meet-now/nb-NO/LocalizedStrings.json";
import pl_pl from "../translations-meet-now/pl-PL/LocalizedStrings.json";
import pt_br from "../translations-meet-now/pt-BR/LocalizedStrings.json";
import ro_ro from "../translations-meet-now/ro-RO/LocalizedStrings.json";
import sv_se from "../translations-meet-now/sv-SE/LocalizedStrings.json";
import tr_tr from "../translations-meet-now/tr-TR/LocalizedStrings.json";
import uk_ua from "../translations-meet-now/uk-UA/LocalizedStrings.json";
import zh_cn from "../translations-meet-now/zh-CN/LocalizedStrings.json";
import zh_tw from "../translations-meet-now/zh-TW/LocalizedStrings.json";
import fr_fr from "../translations-meet-now/fr-FR/LocalizedStrings.json";
import ru_ru from "../translations-meet-now/ru-RU/LocalizedStrings.json";
import { TranslationKeys } from "../configuration/IConfiguration";

class TranslationsHelper {

    public GetTranslation(key: TranslationKeys): string {
        const language = languageHelper.GetCurrentLanguage();

        switch (language.toLowerCase()) {
            case "en-us": {
                return en_us[key];
            }
            case "ar-sa": {
                return ar_sa[key];
            }
            case "bg-bg": {
                return bg_bg[key];
            }
            case "cs-cz": {
                return cs_cz[key];
            }
            case "da-dk": {
                return da_dk[key];
            }
            case "de-de": {
                return de_de[key];
            }
            case "el-gr": {
                return el_gr[key];
            }
            case "es-es": {
                return es_es[key];
            }
            case "et-ee": {
                return et_ee[key];
            }
            case "fi-fi": {
                return fi_fi[key];
            }
            case "he-il": {
                return he_il[key];
            }
            case "hi-in": {
                return hi_in[key];
            }
            case "hu-hu": {
                return hu_hu[key];
            }
            case "id-id": {
                return id_id[key];
            }
            case "it-it": {
                return it_it[key];
            }
            case "fr-fr": {
                return fr_fr[key];
            }
            case "ja-jp": {
                return ja_jp[key];
            }
            case "ko-kr": {
                return ko_kr[key];
            }
            case "nl-nl": {
                return nl_nl[key];
            }
            case "nb-no": {
                return nb_no[key];
            }
            case "pl-pl": {
                return pl_pl[key];
            }
            case "pt-br": {
                return pt_br[key];
            }
            case "ro-ro": {
                return ro_ro[key];
            }
            case "sv-se": {
                return sv_se[key];
            }
            case "tr-tr": {
                return tr_tr[key];
            }
            case "uk-ua": {
                return uk_ua[key];
            }
            case "zh-cn": {
                return zh_cn[key];
            }
            case "zh-tw": {
                return zh_tw[key];
            }
            case "ru-ru": {
                return ru_ru[key];
            }            
            // TODO: add more here
            default: {
                return en_us[key];
            }
        }
    }
}

export const translationsHelper  = new TranslationsHelper();